// Components==============
import { faGripLines } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/UI/Button/Button';
import Textarea from 'components/UI/Form/Textarea';
import ProjectEvidenceButton from 'components/UI/ProjectEvidenceButton/ProjectEvidenceButton';
import { ProjectProcessContext } from 'components/UI/ProjectProcess/ProjectProcess';
import { usePermission } from 'hooks/usePermission';
import { useTranslate } from 'hooks/useTranslate';
import { ProjectDetailsContext } from 'pages/Workspace/ProjectDetails/ProjectDetails';
import React, { useContext } from 'react';
import { DraggableProvidedDragHandleProps } from 'react-beautiful-dnd';
import { ProcessContext } from '../Process';
import './Bottom.module.scss';
// =========================

export default function Bottom({
  processDragHandler,
  onbekend,
}: {
  processDragHandler?: DraggableProvidedDragHandleProps;
  onbekend?: boolean;
}) {
  const translate = useTranslate();

  const { setProcessGroups, project, isLocked } = useContext(
    ProjectDetailsContext
  );

  const { editableProcess, process, dragHandleProps } = useContext(
    ProcessContext
  );

  const { isEditable, inModal, processGroups } = useContext(
    ProjectProcessContext
  );

  const description =
    editableProcess?.process_type === 'App\\Phase'
      ? (processGroups?.find(
          (group) =>
            group.processId === editableProcess?.processId &&
            group.process_type === editableProcess.process_type
        )?.description as string | undefined)
      : processGroups
          ?.map(
            (group) =>
              group.activities.find(
                (activity) =>
                  activity.processId === editableProcess?.processId &&
                  activity.process_type === editableProcess?.process_type
              )?.description as string | undefined
          )
          .filter((exists) => exists)[0];

  function onChange(
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) {
    if (editableProcess?.process_type === 'App\\Phase')
      return setProcessGroups((prev) =>
        prev.map((group) => {
          const match =
            group.processId === editableProcess?.processId &&
            group.process_type === editableProcess.process_type;

          if (match)
            return {
              ...group,
              description: e.target.value,
            };

          return group;
        })
      );

    setProcessGroups((prev) =>
      prev.map((group) => {
        if (
          group.activities.find(
            (activity) =>
              activity.processId === editableProcess?.processId &&
              (activity.process_type === editableProcess?.process_type) !==
                undefined
          )
        )
          return {
            ...group,
            activities: group.activities.map((activity) => {
              if (
                activity.processId === editableProcess?.processId &&
                activity.process_type === editableProcess?.process_type
              )
                return { ...activity, description: e.target.value };
              return activity;
            }),
          };

        return group;
      })
    );
  }

  const dragHandler = dragHandleProps || processDragHandler;

  const isTeacher = usePermission(['Docent', 'super-admin', 'Extern']);

  const isCheckpoint =
    process?.process_id === 3 && process?.process_type === 'App\\Activity';

  const teacherProject = !project?.members.find((m) => {
    const roles = m.user.roles.map((r) => r.name);

    const isStudent =
      roles.includes('Leerling') || roles.includes('Leerling Portfolio');

    return isStudent;
  });

  return (
    <div styleName="wrapper">
      {isEditable ? (
        <div styleName="edit-bottom">
          <div {...dragHandler}>
            <FontAwesomeIcon icon={faGripLines} />
          </div>
          <Textarea
            ext_formValue={onbekend ? '' : description || ''}
            ext_onChange={onChange}
            name={`${process?.process_type}-${process?.id}`}
            placeholder={translate('general.terms.explanation')}
          />
        </div>
      ) : (
        // Don't show description if token Unknown
        <>
          {description && !onbekend && (
            <div>
              <strong>
                {translate(
                  `general.terms.${
                    editableProcess?.process_type === 'App\\Phase'
                      ? 'description'
                      : 'explanation'
                  }`
                )}
              </strong>
              <p styleName="description">{description}</p>
            </div>
          )}
        </>
      )}
      {!!(!isEditable && !inModal && process) && (
        <>
          {isCheckpoint ? (
            <>
              {(!isTeacher || (isTeacher && !teacherProject)) && (
                <>
                  <div styleName="bar" />
                  <Button
                    color="grey"
                    to={`/groei/reflecteren/${project?.id}/${
                      isTeacher ? '' : process?.id
                    }`}
                    inactive={isLocked}
                  >
                    {isTeacher
                      ? translate('general.terms.judge')
                      : translate('general.terms.reflect')}
                  </Button>
                </>
              )}
            </>
          ) : (
            <ProjectEvidenceButton process={process!} />
          )}
        </>
      )}
    </div>
  );
}
